import { useQuery } from "@tanstack/react-query";
import { queryService } from "../services/query-service";
import type { CategoryPreferencesResponse } from "../models/api-types";

/**
 * Hook for fetching category preferences from backend
 * Returns all category types with their available attributes
 * @param country - Country code (default: "TR")
 */
export const useCategoryPreferences = (country: string = "TR") => {
  return useQuery<CategoryPreferencesResponse>({
    queryKey: ["preferences", "categories", country],
    queryFn: async () => {
      return await queryService.getCategoryPreferences(country);
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 1,
  });
};

